// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_24uW4","inSettingsPanel":"_3X15G","featuredLabel":"_3awH3","disabled":"_2Dhws","label":"_2jrST"};